import { Table, styled } from '@mui/material';

export const StyledTable = styled(Table)(() => ({
  border: 'none',
  borderCollapse: 'collapse',
}));
